/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateSalesRepResponseFromDiscriminatorValue, createDeleteSalesRepResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListOrganizationSalesRepsResponseFromDiscriminatorValue, createUpdateSalesRepResponseFromDiscriminatorValue, serializeCreateSalesRepRequest, serializeCreateSalesRepResponse, serializeDeleteSalesRepRequest, serializeDeleteSalesRepResponse, serializeUpdateSalesRepRequest, serializeUpdateSalesRepResponse, type CreateSalesRepRequest, type CreateSalesRepResponse, type DeleteSalesRepRequest, type DeleteSalesRepResponse, type ErrorResponse, type InternalErrorResponse, type ListOrganizationSalesRepsResponse, type UpdateSalesRepRequest, type UpdateSalesRepResponse } from '../../../models/index.js';
// @ts-ignore
import { ActivateRequestBuilderRequestsMetadata, type ActivateRequestBuilder } from './activate/index.js';
// @ts-ignore
import { BackfillUserChannelsRequestBuilderRequestsMetadata, type BackfillUserChannelsRequestBuilder } from './backfillUserChannels/index.js';
// @ts-ignore
import { DeactivateRequestBuilderRequestsMetadata, type DeactivateRequestBuilder } from './deactivate/index.js';
// @ts-ignore
import { DiscountpermissionsRequestBuilderRequestsMetadata, type DiscountpermissionsRequestBuilder } from './discountpermissions/index.js';
// @ts-ignore
import { ExistsRequestBuilderRequestsMetadata, type ExistsRequestBuilder } from './exists/index.js';
// @ts-ignore
import { type WithSalesRepItemRequestBuilder, WithSalesRepItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { ReconcileRepnumChannelsRequestBuilderRequestsMetadata, type ReconcileRepnumChannelsRequestBuilder } from './reconcileRepnumChannels/index.js';
// @ts-ignore
import { ResendWelcomeRequestBuilderRequestsMetadata, type ResendWelcomeRequestBuilder } from './resendWelcome/index.js';
// @ts-ignore
import { type ViewallcustomersRequestBuilder, ViewallcustomersRequestBuilderRequestsMetadata } from './viewallcustomers/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps
 */
export interface SalesrepsRequestBuilder extends BaseRequestBuilder<SalesrepsRequestBuilder> {
    /**
     * The activate property
     */
    get activate(): ActivateRequestBuilder;
    /**
     * The backfillUserChannels property
     */
    get backfillUserChannels(): BackfillUserChannelsRequestBuilder;
    /**
     * The deactivate property
     */
    get deactivate(): DeactivateRequestBuilder;
    /**
     * The discountpermissions property
     */
    get discountpermissions(): DiscountpermissionsRequestBuilder;
    /**
     * The exists property
     */
    get exists(): ExistsRequestBuilder;
    /**
     * The reconcileRepnumChannels property
     */
    get reconcileRepnumChannels(): ReconcileRepnumChannelsRequestBuilder;
    /**
     * The resendWelcome property
     */
    get resendWelcome(): ResendWelcomeRequestBuilder;
    /**
     * The viewallcustomers property
     */
    get viewallcustomers(): ViewallcustomersRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.organizations.salesreps.item collection
     * @param salesRepId Unique identifier of the item
     * @returns {WithSalesRepItemRequestBuilder}
     */
     bySalesRepId(salesRepId: string) : WithSalesRepItemRequestBuilder;
    /**
     * Deletes a Sales Rep in the Organization.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DeleteSalesRepResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DeleteSalesRepResponse | undefined>;
    /**
     * List Sales Reps that belong to an Organization with paging and sorting options
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListOrganizationSalesRepsResponse[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<SalesrepsRequestBuilderGetQueryParameters> | undefined) : Promise<ListOrganizationSalesRepsResponse[] | undefined>;
    /**
     * Updates a Sales Rep's RepNumber in the Organization.
     * @param body Represents a request to update a Sales Representative's RepNumber.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<UpdateSalesRepResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     patch(body: UpdateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<UpdateSalesRepResponse | undefined>;
    /**
     * Create a Sales Rep for an Organization
     * @param body Represents a request to create a Sales Representative.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateSalesRepResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateSalesRepResponse | undefined>;
    /**
     * Deletes a Sales Rep in the Organization.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * List Sales Reps that belong to an Organization with paging and sorting options
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SalesrepsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Updates a Sales Rep's RepNumber in the Organization.
     * @param body Represents a request to update a Sales Representative's RepNumber.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: UpdateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Create a Sales Rep for an Organization
     * @param body Represents a request to create a Sales Representative.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * List Sales Reps that belong to an Organization with paging and sorting options
 */
export interface SalesrepsRequestBuilderGetQueryParameters {
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. Default value is "RepNumber".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const SalesrepsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SalesrepsRequestBuilderNavigationMetadata: Record<Exclude<keyof SalesrepsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySalesRepId: {
        navigationMetadata: WithSalesRepItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["salesRepId"],
    },
    activate: {
        requestsMetadata: ActivateRequestBuilderRequestsMetadata,
    },
    backfillUserChannels: {
        requestsMetadata: BackfillUserChannelsRequestBuilderRequestsMetadata,
    },
    deactivate: {
        requestsMetadata: DeactivateRequestBuilderRequestsMetadata,
    },
    discountpermissions: {
        requestsMetadata: DiscountpermissionsRequestBuilderRequestsMetadata,
    },
    exists: {
        requestsMetadata: ExistsRequestBuilderRequestsMetadata,
    },
    reconcileRepnumChannels: {
        requestsMetadata: ReconcileRepnumChannelsRequestBuilderRequestsMetadata,
    },
    resendWelcome: {
        requestsMetadata: ResendWelcomeRequestBuilderRequestsMetadata,
    },
    viewallcustomers: {
        requestsMetadata: ViewallcustomersRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SalesrepsRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: SalesrepsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDeleteSalesRepResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteSalesRepRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: SalesrepsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createListOrganizationSalesRepsResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: SalesrepsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createUpdateSalesRepResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateSalesRepRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: SalesrepsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateSalesRepResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateSalesRepRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
